<script>
import Layout from '@layouts/public.vue'
import { authMethods } from '@state/helpers'
import appConfig from '@/app.config'
import baseMixin from '@mixins/baseMixin'
import { mapGetters } from 'vuex'

export default {
  metaInfo: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  mixins: [baseMixin],
  data() {
    return {
      authError: null,
    }
  },
  computed: {
    ...mapGetters({
      isLoadingAuth: 'auth/isLoadingAuth',
    }),
    getAppTitle() {
      return appConfig.title
    },
  },
  methods: {
    ...authMethods,
    async loginWithMsal() {
      await this.logIn(this.$route.query.redirectFrom).catch((error) => {
        this.authError = error
      })
    },
  },
}
</script>

<template>
  <Layout>
    <v-layout align-center justify-center>
      <v-card
        elevation="0"
        class="transparent d-flex align-center flex-column text-center"
        style="width: 400px;"
      >
        <section v-if="!isEmbedded">
          <img
            src="../../assets/images/logo_white.svg"
            width="240"
            height="76"
          />

          <h1 class="title white--text font-weight-bold mb-8 mt-6">
            Right Educator, Right Place, <br />
            Right Time
          </h1>
        </section>

        <v-card-actions>
          <BaseButton
            light
            block
            x-large
            depressed
            :loading="isLoadingAuth"
            @click="loginWithMsal"
          >
            <BaseIcon left name="mdi-microsoft"></BaseIcon>
            {{
              isMobileViewPort ? 'Login' : 'Login with your Microsoft Account'
            }}
          </BaseButton>
        </v-card-actions>
      </v-card>
    </v-layout>
  </Layout>
</template>
